import styled from '@emotion/styled';

import { focusRing, hoverable, pressable } from '@/design-system';

export const CopyCodeButton = styled('button')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing[8],
  padding: 0,
  border: 0,
  background: 'none',
  cursor: 'pointer',
  borderRadius: theme.radius[8],
  ...hoverable(theme, 'surface'),
  ...pressable(theme, 'surface'),
  ...focusRing(theme, { inset: false }),
}));

export const CopyCodeCell = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  width: 38,
  height: 52,
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  color: theme.colors.text.primary,
  backgroundColor: theme.colors.background.overlay,
  border: `1px solid ${theme.colors.border.default}`,
  borderRadius: theme.radius[8],
  fontFamily: 'DM Sans, sans-serif',
  fontSize: 16,
  fontWeight: 500,
  lineHeight: '24px',
  fontVariantNumeric: 'tabular-nums',
}));
